import {
    trigger,
    state,
    style,
    animate,
    transition,
    query,
    group
} from '@angular/animations';
import {AbsoluteSourceSpan} from '@angular/compiler';


export let slideRightUp = trigger('slideRightUp', [
    state('void', style({ transform: 'translateY(100%)', opacity: 0, height: 0, margin: 0 })),

    transition(':enter', [
        style({ transform: 'translateY(20px)', opacity: 0, height: 0, margin: 0 }),
        animate('500ms ease-out', style({ transform: 'translateY(0)', opacity: 1, height: '*', margin: '*' }))
    ]),

    transition(':leave', [
        animate('400ms ease-in', style({ transform: 'translateX(100%)', opacity: 0, height: 0, margin: 0 }))
    ])
]);

export let slideRight = trigger('slideRight', [
    transition(':enter', [
        style({transform: 'translateX(-100%)', opacity: 0}),
        animate(700)
    ]),
    transition(':leave', [
        animate(350, style({transform: 'translateX(100%)'}))
    ])
])

export let slideRight2 = trigger('slideRight2', [
    transition(':enter', [
        style({position: 'fixed', left: '-100%', opacity: 0}),
        animate(1000)
    ]),
    transition(':leave', [
        animate(1000, style({position: 'fixed', left: '100%'}))
    ])
])

export let delay = trigger('delay', [
    transition(':leave', [
        animate(500)
    ])
])

export let slideUp = trigger('slideUp', [

    state('void', style({transform: 'translateY(100%)', opacity: 0, width: 0})),

    transition('void => *, * => void', [
        animate(500)
    ])
])

export let slideDown = trigger('slideDown', [

    state('void', style({transform: 'translateY(200px)', opacity: 0, width: 0})),

    transition('void => *, * => void', [
        animate(500)
    ])
])

export let slideDown2 = trigger('slideDown', [

    state('void', style({transform: 'translateY(20px)', opacity: 0, width: 0})),

    transition('void => *, * => void', [
        animate(500)
    ])
])

export let slideUpMenu = trigger('slideUpMenu', [

    transition(':enter', [
        style({transform: 'translateY(-100px)', opacity: 0}),
        animate(500)
    ]),
    transition(':leave', [
        animate(500, style({transform: 'translateY(-100px)', opacity: 0}))
    ])
])


// changeDivSize start

const right = [
    query(':enter, :leave', style({position: 'fixed', width: '120%'}), {optional: true}),
    group([
        query(':enter', [style({transform: 'translateX(100%)'}), animate('.3s ease-out', style({transform: 'translateX(0%)'}))], {
            optional: true,
        }),
        query(':leave', [style({transform: 'translateX(0%)'}), animate('.3s ease-out', style({transform: 'translateX(-100%)'}))], {
            optional: true,
        }),
    ]),
];

const left = [
    query(':enter, :leave', style({position: 'fixed', width: '100%'}), {optional: true}),
    group([
        query(':enter', [style({transform: 'translateX(-100%)'}), animate('.3s ease-out', style({transform: 'translateX(0%)'}))], {
            optional: true,
        }),
        query(':leave', [style({transform: 'translateX(0%)'}), animate('.3s ease-out', style({transform: 'translateX(100%)'}))], {
            optional: true,
        }),
    ]),
];

export let changeDivSize = trigger('changeDivSize', [
    transition(':increment', left),
    transition(':decrement', right),
])

// changeDivSize end

export let anim = trigger('anim', [
    state('void', style({opacity: 0.3})),
    state('*', style({opacity: 1})),
    transition(':enter', animate(`.5s ease-out`)),
    transition(':leave', animate(`.1s ease-out`))
])
